import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './WhoNeeds.module.scss';

export const WhoNeedsMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>Who</div>
        <div className={styles.mainSection_2}>TransparenTerra?</div>
        <div className={styles.mainSection_3}>needs</div>
      </div>
    }
    rightContent={null}
  />
);
